import SettingsAlertsEntity from '../../entities/projections/settings/SettingsAlertsEntity';
import SettingsDirectDebitsEntity from '../../entities/projections/settings/SettingsDirectDebitsEntity';
import SettingsEarningsEntity from '../../entities/projections/settings/SettingsEarningsEntity';
import SettingsCategoryTagsEntity from '../../entities/projections/settings/SettingsCategoryTagsEntity';
import SettingsUserTagsEntity from '../../entities/projections/settings/SettingsUserTagsEntity';
import SettingsStandingOrdersEntity from '../../entities/projections/settings/SettingsStandingOrdersEntity';
import Settings from '../../entities/projections/settings/Settings';
export default class ProjectionSettingsParser {
  parseProjectionSettings(response) {
    const settingsDirectDebits = [];
    response.commitments.direct_debits.map((directdebits) => {
      const directDebitsObject = new SettingsDirectDebitsEntity();
      directDebitsObject.directDebitsName = directdebits.display_name;
      directDebitsObject.directDebitsLastKnownDate =
        directdebits.last_payment_date;
      directDebitsObject.directDebitsFrequency = directdebits.frequency;
      directDebitsObject.directDebitsLastKnownAmount =
        directdebits.amount.value;
      settingsDirectDebits.push(directDebitsObject);
      return true;
    });

    const settingsStandingOrders = [];
    response.commitments.standing_orders.map((commitments) => {
      const commitmentsObject = new SettingsStandingOrdersEntity();
      commitmentsObject.standingOrderName = commitments.display_name;
      commitmentsObject.standingOrderLastKnownDate =
        commitments.last_known_date;
      commitmentsObject.standingOrderFrequency = commitments.frequency;
      commitmentsObject.standingOrderLastKnownAmount = commitments.amount.value;
      settingsStandingOrders.push(commitmentsObject);
      return true;
    });

    const settingsEarnings = [];
    response.earnings.map((earnings) => {
      const earningsObject = new SettingsEarningsEntity();
      earningsObject.earningsId = earnings.id;
      earningsObject.earningsName = earnings.display_name;
      earningsObject.earningsLastKnownDate = earnings.last_known_date;
      earningsObject.earningsFrequency = earnings.frequency;
      earningsObject.earningsLastKnownAmount = earnings.amount.value;
      earningsObject.earningsEnabledFlag = earnings.enabled;
      settingsEarnings.push(earningsObject);
      return true;
    });
    const tags = [];
    const settingsCategories = [];
    response.essential_spend.categories.map((categories) => {
      const categoriesObject = new SettingsCategoryTagsEntity();
      categoriesObject.enabledFlag = categories.enabled;
      categoriesObject.id = categories.id;
      categoriesObject.tagName = categories.value;
      settingsCategories.push(categoriesObject);
      return true;
    });

    const settingsUserTags = [];
    response.essential_spend.tags.map((user) => {
      const userTagsObject = new SettingsUserTagsEntity();
      userTagsObject.enabledFlag = user.enabled;
      userTagsObject.id = user.id;
      userTagsObject.tagName = user.value;
      settingsUserTags.push(userTagsObject);
      return true;
    });
    tags.push({ categorytags: settingsCategories, usertags: settingsUserTags });

    const alerts = [];
    const settingsAlertsObject = new SettingsAlertsEntity();
    settingsAlertsObject.alertsAmount =
      response.thresholds.lower.amount.value.toFixed(2);
    settingsAlertsObject.notificationFlag = response.external_notification;
    alerts.push(settingsAlertsObject);

    const settings = new Settings();
    settings.earnings = settingsEarnings;
    settings.commitments = settingsStandingOrders;
    settings.directDebits = settingsDirectDebits;
    settings.alerts = alerts;
    settings.essentialSpends = tags;
    return settings;
  }
  parseProjections() {
    // console.log('called');
  }
}
